export const supportedIdentityFileTypes: { [key: string]: string } = {
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': '.xlsx/.XLSX',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.template': '.xltx/.XLTX',
  'application/vnd.openxmlformats-officedocument.presentationml.template': '.potx/.POTX',
  'application/vnd.openxmlformats-officedocument.presentationml.slideshow': '.ppsx/.PPSX',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation': '.pptx/.PPTX',
  'application/vnd.openxmlformats-officedocument.presentationml.slide': '.sldx/.SLDX',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': '.docx/.DOCX',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.template': '.dotx/.DOTX',
  'application/vnd.ms-excel.addin.macroEnabled.12': '.xlam/.XLAM',
  'application/vnd.ms-excel.sheet.binary.macroEnabled.12': '.xlsb/.XLSB',
  'application/msword': '.doc/.DOC',
  'application/vnd.ms-excel': '.xls/.XLS',
  'application/vnd.ms-powerpoint': '.ppt/.PPT',
  'text/richtext': '.rt/.RT',
  'text/csv': '.csv/.CSV',
  'application/pdf': '.pdf/.PDF',
  'application/vnd.oasis.opendocument.text': '.odt/.ODT',
  'application/vnd.oasis.opendocument.presentation': '.odp/.ODP',
  'application/vnd.oasis.opendocument.spreadsheet': '.ods/.ODS',
  'application/vnd.oasis.opendocument.image': '.odi/.ODI',
  'application/rtf': '.rtf/.RTF',
  'image/bmp': '.bmp/.BMP',
  'image/png': '.png/.PNG',
  'image/gif': '.gif/.GIF',
  'image/ief': '.ief/.IEF',
  'image/jpeg': '.jpg/.jpeg/.JPG/.JPEG',
  'image/pipeg': ' .jfif/.JFIF',
  'image/svg+xml': '.svg/.SVG',
  'image/tiff': '.tif/.TIF',
  'image/x-cmu-raster': '.ras/.RAS',
  'image/x-cmx': '.cmx/.CMX',
  'image/x-icon': '.ico/.ICO',
  'image/x-portable-anymap': '.pnm/.PNM',
  'image/x-portable-bitmap': '.pbm/.PBM',
  'image/x-portable-graymap': '.pgm/PGM',
  'image/x-portable-pixmap': '.ppm/.PPM',
  'image/x-rgb': '.rgb/.RGB',
  'image/x-xbitmap': '.xbm/.XBM',
  'image/x-xpixmap': '.pm/.PM',
  'image/x-xwindowdump': '.xwd/.XWD',
};
